import React, { useState, useEffect, useRef } from 'react';
import { useSwipeable } from 'react-swipeable';
import withAppState from '../mobx/withAppState';
import xmark from '../assets/img/xmark.svg'

const SwipeableContainer = props => {
  const { customClass = null, customInnerClass = null } = props;
  const [isOpen, setIsOpen] = useState(props.slideUpModal);

  const innerModal = useRef(null);  

  const handlers = useSwipeable({ 
    onSwiping: eventData => {
      if (eventData.dir === 'Down') {
        props.setSwipeable(true);
        props.setDragDownModal(eventData.deltaY);
          if (eventData.deltaY > (innerModal.current.clientHeight / 2 || window.innerHeight / 2)) {
            setTimeout(() => {
              props.setDragDownModal(innerModal.current.clientHeight);
              props.handleModalCancel();
            }, 0);
        }
      }
    },
    onSwiped: eventData => {
      props.setSwipeable(false);
      if (eventData.deltaY < (innerModal.current.clientHeight / 2 || window.innerHeight / 2)) {
        props.setDragDownModal(0);
        setIsOpen(!isOpen);
      }
    },
    trackTouch: true,
    trackMouse: false,
  });

  var dragDownHeight = {
    bottom: -props.swipeableModalPosition + 'px',
    touchAction: 'pan-y',
  };

  useEffect(() => {
    document.body.classList.toggle('modal-open', props.slideUpModal);
  }, [props.slideUpModal]);

  const appHeight = window.innerHeight;

  return (
    <div
      style={props.slideUpModal ? dragDownHeight : null}
      {...handlers}
      className={`modal-slide-up ${props.slideUpModal ? 'active' : ''} ${props.swipeable ? 'is-swipeable' : ''} ${
        props.slideOutAnimation ? 'is-animatingOut' : ''
      } ${customClass ? customClass : ''}`}>
      <div style={{maxHeight: appHeight * 0.9}} ref={innerModal} className={`modal-slide-up-inner ${customInnerClass ? customInnerClass : ''}`}>
        <div onClick={() => props.handleModalCancel()} className="modal-close">
          <img src={xmark} className="swipeable-close"></img>
        </div>
        <div className="slide-draw-bar"></div>
        {props.children}
      </div>
    </div>
  );
};

export default withAppState(SwipeableContainer, {
  mobXProps: ({ modalActive, swipeable, swipeableModalPosition, slideOutAnimation }) => ({
    modalActive,
    swipeable,
    swipeableModalPosition,
    slideOutAnimation,
  }),
  mobXActions: ({ closeSlideUpModal, setSwipeable, setDragDownModal }) => ({
    closeSlideUpModal,
    setSwipeable,
    setDragDownModal,
  }),
});
